var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.700001 7.69131C0.313401 7.69131 0 7.39411 0 7.02749V5.03606C0 4.66945 0.313401 4.37225 0.7 4.37225H20.3C20.6866 4.37225 21 4.66945 21 5.03606V7.02749C21 7.39411 20.6866 7.69131 20.3 7.69131H0.700001Z",
    fill: "#5CBF66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.455 2.73483C13.1732 2.48382 13.1594 2.06372 13.4241 1.79652L14.9963 0.209319C15.261 -0.0578867 15.704 -0.0710154 15.9858 0.179995L20.5776 4.27044C20.8593 4.52145 20.8732 4.94155 20.6085 5.20875L19.0362 6.79595C18.7715 7.06316 18.3285 7.07629 18.0467 6.82528L13.455 2.73483Z",
    fill: "#5CBF66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0231 5.15087C18.3049 4.89986 18.7479 4.91299 19.0126 5.18019L20.6085 6.79124C20.8732 7.05845 20.8593 7.47854 20.5776 7.72955L15.9858 11.82C15.704 12.071 15.261 12.0579 14.9963 11.7907L13.4004 10.1796C13.1357 9.91243 13.1496 9.49233 13.4313 9.24132L18.0231 5.15087Z",
    fill: "#5CBF66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/iconArrow.6c95e4ab73021fbbf624700dd3c79dde.svg";
export { ForwardRef as ReactComponent };